import { EventCategory } from "@/types/ui";
import { FrameName } from "../config";
import EventTileEntity from "../EventTileEntity";

class ShepherdsLodgeBuildingTileEntity extends EventTileEntity {
	public static readonly eventType = EventCategory.HUNTING;

	public static readonly frameName = FrameName.SHEPHERDS_LODGE;
}

export default ShepherdsLodgeBuildingTileEntity;
